import React from "react";
import "./footer.css";

function Footer() {
  return <footer className="bottom-footer">Made with ❤️ by Kavya.</footer>;
}

export default Footer;
